<template>
    <div id="inner">
        <b-tabs content-class="col-12" class="row archive-tabs">
            <b-tab title="Reacties" active>
                <on-site :adverts="data.onSite" :finished="finished" @reload="fetch"></on-site>
            </b-tab>
            <b-tab title="In Behandeling">
                <in-offer :adverts="data.inProgress" :finished="finished"  @reload="fetch"></in-offer>
            </b-tab>
            <b-tab title="Archief">
                <offer-archive :adverts="data.history" @loadRest="loadArchive(999)" :finished="finishedArchive"  @reload="fetch"></offer-archive>
            </b-tab>
            <b-tab title="Overige Brieven">
                <letter-archive :finished="finished"></letter-archive>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import onSite from "./_reaction/onSite";
    import inOffer from "./_reaction/inOffer";
    import offerArchive from "./_reaction/offerArchive";
    import letterArchive from "./_reaction/letterArchive";
    import {reactionService} from "../_services/reaction.service";

    export default {
        components: {offerArchive, inOffer, onSite, letterArchive},
        data: () => {
            return {
                data: {
                    onSite: [],
                    inProgress: [],
                    history: []
                },
                finished: false,
                finishedArchive: false
            }
        },
        name: 'Reaction',
        mounted() {
            this.fetch()
            this.$emit('childInitialized', {
                title: 'Uw Reacties'
            })
        },
        methods: {
            fetch() {
                this.finished = false
                reactionService.getReactions(0).then((data) => {
                    this.data = data
                    this.finished = true
                    this.loadArchive(10)
                })
            },
            loadArchive(count) {
                this.finishedArchive = false
                reactionService.getReactions(count).then((data) => {
                    this.data.history = data.history
                    this.finishedArchive = true
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item-icon {
        width: 100px;
    }
    #inner {
        padding: 15px !important;
    }
</style>
